import React from 'react'
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

const innerHeader = (props) => {
  return (
    <div className="bottom-nav ">
   <Container>
    <Row>
        <Col>
                <h1 >{props.title}</h1>
        </Col>
    </Row>
   </Container>
    </div>
  )
}

export default innerHeader